
import Vue from 'vue'

interface Data {}
interface Methods {}
interface Computed {}
interface Props {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Dashboard'
})
